// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__boDxp","tab":"Tabs_tab__KzyZ+","active":"Tabs_active__5OGe+"};